import { useCallback, useEffect, useState } from 'react';
import { ExampleLinks, getExampleLinks } from '../../../api/cafAutomation';
import { isMissingRoute } from '../saveEngine';
import { LoadStatus } from './useAiSwitch';

export interface ExampleLinksState { status: LoadStatus; data: ExampleLinks | null; reload: () => void }

/** Teach the AI's Workflow column. `missing` (older backend) or `error` hides it; nothing else changes. */
export const useExampleLinks = (enabled: boolean): ExampleLinksState => {
  const [status, setStatus] = useState<LoadStatus>(enabled ? 'loading' : 'missing');
  const [data, setData] = useState<ExampleLinks | null>(null);
  const [tick, setTick] = useState(0);
  const reload = useCallback(() => setTick((count) => count + 1), []);

  useEffect(() => {
    if (!enabled) return undefined;
    const controller = new AbortController();
    const { signal } = controller;
    const run = async () => {
      try {
        const next = await getExampleLinks(signal);
        if (signal.aborted) return;
        if (!next || typeof next.links !== 'object' || !Array.isArray(next.workflows)) throw new Error('unexpected links');
        setData(next);
        setStatus('ready');
      } catch (err) {
        if (signal.aborted) return;
        setData(null);
        setStatus(isMissingRoute(err) ? 'missing' : 'error');
      }
    };
    void run();
    return () => controller.abort();
  }, [enabled, tick]);

  return { status, data, reload };
};
